import { clone } from '../object/clone';
import { _findIndex } from './_findIndex';
import { _isArray } from './_isArray';
import { modelSplitter } from './modelSplitter';

export function getValueFromScope(scope, model, options = {}) {
  const { isImmutable = true } = options;
  const res = modelSplitter(model).reduce((acc, cur) => {
    if (typeof acc === 'undefined') {
      return acc;
    }
    if (_isArray(cur)) {
      const index = _findIndex(cur);
      const field = cur.replace(/\[.*\]/, '');
      return acc[field] ? acc[field][index] : acc[field];
    }
    return acc[cur];
  }, scope);
  return isImmutable ? clone(res) : res;
}
